import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { add_receptionist, update_receptionist } from "../../data/ApiEndpoints";
import { commonPostPutFormData } from "../../redux/reducers/commonApiSlice";
import { fetchGymData } from "../../data/APIs";
import {
  fetchInHouseUsersData,
  fetchReceptionistShiftsData,
} from "../../redux/reducers/dropdownApiSlice";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import SelectDropdown from "../components-react/SelectDropdown";
import { showConfirmAlert } from "../components-react/ReactAlert";

const ReceptionistForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { postPutLoadingFormData } = useSelector((state) => state.common);
  const { inhouseUsers, receptionistShifts } = useSelector(
    (state) => state.dropdown
  );

  const forminitials = {
    staffName: rowData?.name ? rowData.name : "",
    staffMobile: rowData?.mobile ? rowData.mobile : "",
    staffEmail: rowData?.email ? rowData.email : "",

    selectedReportingManager:
      rowData?.reporting_to && rowData?.reporting_to_name
        ? {
            value: rowData.reporting_to,
            label: rowData.reporting_to_name,
          }
        : "",

    selectedGym:
      rowData?.gym_id && rowData?.gym_name
        ? {
            value: rowData.gym_id,
            label: rowData.gym_name,
          }
        : "",

    totalExperience: rowData?.experiance ? rowData.experiance : "",

    joiningDate: rowData?.joining_date ? rowData.joining_date : "",
    fullAddress: rowData?.address ? rowData.address : "",

    bankName: rowData?.bank_name ? rowData.bank_name : "",
    accountNumber: rowData?.account_number ? rowData.account_number : "",
    ifscCode: rowData?.ifsc_code ? rowData.ifsc_code : "",

    aadharCard: rowData?.aadhar_card ? rowData.aadhar_card : "",
    panCard: rowData?.pan_card ? rowData.pan_card : "",

    checkedShifts: Array.isArray(rowData?.shift_id)
      ? rowData.shift_id
          .filter((shift) => shift.shift_start && shift.shift_end)
          .map((shift) => shift?.shift_id)
      : [],

    isActive: isEdit && rowData?.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});

  const onChangeInput = (e) => {
    const { name, value, type, checked, files } = e.target;

    setFormValues((prevs) => {
      let newValue = value;

      if (name === "staffMobile") {
        newValue = value.replace(/\D/g, "").slice(0, 10);
      }

      if (type === "file") {
        newValue = files?.[0] || null;
      }

      if (name === "checkedShifts") {
        const updatedCheckedShifts = checked
          ? [
              ...(Array.isArray(prevs.checkedShifts)
                ? prevs.checkedShifts
                : []),
              value,
            ]
          : (Array.isArray(prevs.checkedShifts)
              ? prevs.checkedShifts
              : []
            ).filter((id) => id !== value);

        return { ...prevs, checkedShifts: updatedCheckedShifts };
      }

      if (name === "isActive") {
        return { ...prevs, [name]: checked };
      }

      return { ...prevs, [name]: newValue };
    });
  };

  const validateForm = (formValues) => {
    let errors = {};

    if (!formValues.staffName) errors.staffName = "Required!";

    if (!formValues.staffMobile) {
      errors.staffMobile = "Required!";
    } else if (!/^\d{10}$/.test(formValues.staffMobile)) {
      errors.staffMobile = "Must be exactly 10 digits!";
    }

    if (!formValues.staffEmail) {
      errors.staffEmail = "Required!";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.staffEmail)) {
      errors.staffEmail = "Invalid email format!";
    } else if (formValues.staffEmail.endsWith("@yopmail.com")) {
      errors.staffEmail = "Yopmail is not allowed!";
    }

    if (formValues.totalExperience !== 0 && !formValues.totalExperience)
      errors.totalExperience = "Required!";

    if (!formValues.selectedReportingManager)
      errors.selectedReportingManager = "Required!";

    if (!formValues.selectedGym) errors.selectedGym = "Required!";

    if (!formValues.joiningDate) errors.joiningDate = "Required!";

    if (!formValues.fullAddress) errors.fullAddress = "Required!";

    if (!formValues.bankName) errors.bankName = "Required!";

    if (!formValues.accountNumber) errors.accountNumber = "Required!";

    if (!formValues.ifscCode) errors.ifscCode = "Required!";

    if (formValues.checkedShifts?.length === 0)
      errors.checkedShifts = "Required!";

    if (!isEdit) {
      if (!formValues.aadharCard) errors.aadharCard = "Required!";
      if (!formValues.panCard) errors.panCard = "Required!";
    }

    return errors;
  };

  const handleSubmitForm = async (requestBody) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_receptionist : add_receptionist;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        isEdit && closeModal();
        isEdit && callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = () => {
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const userData = {
        name: formValues.staffName || "",
        email: formValues.staffEmail || "",
        mobile: formValues.staffMobile || "",

        reporting_to: formValues.selectedReportingManager?.value || "",
        reporting_to_name: formValues.selectedReportingManager?.label || "",
        added_by: userInfoData?.uid || userInfoData?.user_id || "",

        joining_date: formValues.joiningDate || "",

        address: formValues.fullAddress || "",

        experiance: formValues.totalExperience || "",

        bank_name: formValues.bankName || "",
        account_number: formValues.accountNumber || "",
        ifsc_code: formValues.ifscCode?.toLocaleUpperCase() || "",

        aadhar_card: formValues.aadharCard || "",
        pan_card: formValues.panCard || "",

        gym_id: formValues.selectedGym?.value || "",

        shift_id: formValues.checkedShifts?.toString(),

        status: formValues.isActive ? "active" : "inactive",
      };

      const formData = new FormData();

      for (const key in userData) {
        if (userData.hasOwnProperty(key)) {
          if (userData[key] instanceof File) {
            formData.append(key, userData[key]);
          } else {
            formData.append(key, userData[key].toString());
          }
        }
      }

      if (isEdit) {
        formData.append("uid", rowData.uid);
      }

      const handleConfirm = async () => {
        handleSubmitForm(formData);
      };

      showConfirmAlert(
        handleConfirm,
        `Confirm Before Submit!`,
        "Edit Form",
        "Submit Form"
      );
    }
  };

  function getInhouseUsers() {
    dispatch(
      fetchInHouseUsersData({
        token: userInfoData?.token,
        qps: "user_types=admin",
        pageNo: 1,
        limit: 1000,
      })
    );
  }

  function getReceptionistShifts() {
    const filters = {
      page: 1,
      limit: 1000,
      status: "active",
    };

    dispatch(
      fetchReceptionistShiftsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
    getReceptionistShifts();
    getInhouseUsers();
  }, []);

  return (
    <>
      <CommonHeadingNBtns
        title="Manage Receptionists"
        onClose={closeModal}
        isLoading={postPutLoadingFormData}
        isDisabled={postPutLoadingFormData}
        btnTxt="Submit"
        onClick={onSubmit}
      />

      <div className="form-container mb30">
        <form className="formContainer">
          <div className="formInputsGrid fourGridSystem">
            <div className="formInputBox">
              <label htmlFor="staffName" className={`formInputLabel `}>
                Full Name <span className="required">*</span>
              </label>

              <input
                type="text"
                placeholder="Enter Full Name"
                className={`formInput ${
                  formErrors?.staffName ? "formError" : ""
                }`}
                name="staffName"
                value={formValues.staffName}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="staffMobile" className={`formInputLabel `}>
                mobile number <span className="required">*</span>
              </label>

              <input
                type="number"
                placeholder="Enter Mobile Number"
                className={`formInput ${
                  formErrors?.staffMobile ? "formError" : ""
                }`}
                name="staffMobile"
                value={formValues.staffMobile}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="staffEmail" className={`formInputLabel `}>
                email address <span className="required">*</span>
              </label>

              <input
                type="email"
                placeholder="Enter Email Address"
                className={`formInput ${
                  formErrors?.staffEmail ? "formError" : ""
                }`}
                name="staffEmail"
                value={formValues.staffEmail}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="selectedGym" className={`formInputLabel`}>
                gym name <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selectedGym ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={gymData}
                  selectedOption={formValues.selectedGym}
                  setSelectedOption={(selectedValue) =>
                    setFormValues((prevs) => ({
                      ...prevs,
                      selectedGym: selectedValue,
                    }))
                  }
                  name="Gym"
                />
              </div>
            </div>

            <div className="formInputBox">
              <label
                htmlFor="selectedReportingManager"
                className={`formInputLabel`}
              >
                reporting manager <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedReportingManager ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={inhouseUsers}
                  selectedOption={formValues.selectedReportingManager}
                  setSelectedOption={(selectedValue) =>
                    setFormValues((prevs) => ({
                      ...prevs,
                      selectedReportingManager: selectedValue,
                      selectedExperties: [],
                    }))
                  }
                  name="reporting manager"
                />
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="totalExperience" className={`formInputLabel `}>
                Years of experience <span className="required">*</span>
              </label>

              <input
                type="number"
                placeholder="Enter year of experience"
                className={`formInput ${
                  formErrors?.totalExperience ? "formError" : ""
                }`}
                name="totalExperience"
                value={formValues.totalExperience}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="joiningDate" className={`formInputLabel `}>
                joining date
                <span className="required">*</span>
              </label>

              <input
                type="date"
                className={`formInput ${
                  formErrors?.joiningDate ? "formError" : ""
                } ${formValues.joiningDate ? "date-has-value" : ""}`}
                name="joiningDate"
                value={formValues.joiningDate}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox gridSpanFour">
              <label htmlFor="fullAddress" className="formInputLabel">
                Full Address <span className="required">*</span>
              </label>

              <textarea
                name="fullAddress"
                className={`formInput ${
                  formErrors?.fullAddress ? "formError" : ""
                }`}
                placeholder="Enter full Address"
                value={formValues.fullAddress}
                onChange={onChangeInput}
              ></textarea>
            </div>

            <div className="formInputBox">
              <label htmlFor="bankName" className={`formInputLabel `}>
                Bank Name <span className="required">*</span>
              </label>

              <input
                type="text"
                placeholder="Enter Bank Name"
                className={`formInput ${
                  formErrors?.bankName ? "formError" : ""
                }`}
                name="bankName"
                value={formValues.bankName}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="accountNumber" className={`formInputLabel `}>
                account number <span className="required">*</span>
              </label>

              <input
                type="number"
                placeholder="Enter Account Number"
                className={`formInput ${
                  formErrors?.accountNumber ? "formError" : ""
                }`}
                name="accountNumber"
                value={formValues.accountNumber}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="ifscCode" className={`formInputLabel `}>
                IFSC Code <span className="required">*</span>
              </label>

              <input
                type="text"
                placeholder="Enter Bank Name"
                className={`formInput ${
                  formErrors?.ifscCode ? "formError" : ""
                }`}
                name="ifscCode"
                value={formValues.ifscCode}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="aadharCard" className={`formInputLabel`}>
                Aadhar card
                {isEdit ? (
                  <span className="not required">(Optional)</span>
                ) : (
                  <span className="required">*</span>
                )}
              </label>

              <input
                accept="image/*,application/pdf"
                type="file"
                className={`formInput ${
                  formErrors.aadharCard ? "formError" : ""
                }`}
                name="aadharCard"
                file={formValues.aadharCard || ""}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="panCard" className={`formInputLabel`}>
                Pan Card
                {isEdit ? (
                  <span className="not required">(Optional)</span>
                ) : (
                  <span className="required">*</span>
                )}
              </label>

              <input
                accept="image/*,application/pdf"
                type="file"
                className={`formInput ${formErrors.panCard ? "formError" : ""}`}
                name="panCard"
                file={formValues.panCard || ""}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox checkbox-wrapper span2">
              <label htmlFor="checkedShifts" className="formInputLabel">
                choose shift time <span className="required">*</span>
              </label>

              <div
                className={`flex-box ${
                  formErrors?.checkedShifts ? "formError" : ""
                }`}
                style={{ borderRadius: "10px" }}
              >
                {receptionistShifts?.length > 0 ? (
                  receptionistShifts?.map((shift, index) => {
                    const isChecked = formValues.checkedShifts?.includes(
                      shift?.value
                    );

                    return (
                      <label
                        className={`checkboxLabel ${isChecked ? "active" : ""}`}
                        key={index}
                      >
                        <input
                          type="checkbox"
                          name="checkedShifts"
                          value={shift.value}
                          checked={isChecked}
                          onChange={onChangeInput}
                        />
                        {shift?.label || "-"}
                      </label>
                    );
                  })
                ) : (
                  <span className="info">No shift found</span>
                )}
              </div>
            </div>
          </div>
          <div className="formInputsGrid switchInputs">
            <div className="formInputBox formInputSwitchBox">
              <div
                className={`commonWrapper commonSwitchWrapper no-border ${
                  formErrors?.isActive ? "formError" : ""
                }`}
              >
                <Form.Check
                  type="switch"
                  name="isActive"
                  label={`${formValues.isActive ? "Active" : "Not Active"}`}
                  checked={formValues.isActive}
                  onChange={onChangeInput}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default ReceptionistForm;
